import React, { useEffect, useState } from "react";
import { FiHeart } from "react-icons/fi"; // Heart icon, optional
import PrimaryButton from "../../common/PrimaryButton";
import hand_heart from "../../../Assets/Images/home/testimonials/hand_heart_white.png";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../utils/axios";

const InvestmentInHumanity = () => {
  const [specialCampId, setSpecialCampId] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const getSpecial = async () => {
      try {
        const response = await axiosInstance.get("/campaigns/special-camp");
        setSpecialCampId(response.data?._id);
      } catch (error) {
        console.log("Error setting special campaign id", error);
      }
    };
    getSpecial();
  }, []);
  const handleGiveForACauseClick = () => {
    navigate(`/campaigns/${specialCampId}`);
  };
  return (
    <section
      className="bg-gray-900 text-white py-16 px-6 sm:px-12 md:px-24 lg:px-32 relative"
      data-aos="fade-up"
      data-aos-anchor-placement="top-bottom"
      data-aos-duration="800"
      data-aos-once="true"
    >
      {/* Optional icon */}
      <div
        className="absolute left-0 bottom-0 text-white text-6xl hidden sm:block"
        data-aos="fade-right"
        data-aos-delay="200"
      >
        <img src={hand_heart} className="w-32 invert-0" alt="hand_heart" />
      </div>

      {/* Content */}
      <div className="max-w-[95%] sm:max-w-[80%] md:max-w-[70%] mx-auto text-center">
        <h2
          className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 leading-snug"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          Kindness Given Is Never A Loss—It’s An Investment In Humanity.
        </h2>
        <p
          className="text-gray-300 text-sm sm:text-base md:text-lg mb-8"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          We are a young-blooded multifaceted organization filled with immense
          passion and a belief that everything is possible with the right amount
          of determination!
        </p>

        <div data-aos="fade-up" data-aos-delay="300">
          <PrimaryButton
            onClick={() => handleGiveForACauseClick()}
            text="Donate for a cause"
            bgColor="bg-[#FCC101]"
            className="hover:bg-[#FCC101] hover:text-black"
          />
        </div>
      </div>
    </section>
  );
};

export default InvestmentInHumanity;
